import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';

export function UnlicensedNotice({
    licenseRequired,
}: {
    licenseRequired: boolean;
}) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);

    if (licenseRequired) {
        return (
            <div className="border border-danger-300 rounded-[10px] p-4 text-sm text-danger-200">
                {t('license.unlicensed.locked')}
            </div>
        );
    }
    return (
        <div className="border border-grey-600 rounded-[10px] p-4 text-sm text-grey-200">
            {t('license.unlicensed.unenforced')}
        </div>
    );
}
